import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useAuth } from "@/lib/auth";
import { Sidebar } from "./Sidebar";
import { AppTopBar } from "./TopBar";
import { ActiveRoleBanner } from "./FounderProfileSwitcher";
import { CommandPalette } from "@/components/altiora/CommandPalette";
import { FeedbackAutoPrompt } from "@/components/altiora/FeedbackAutoPrompt";
import { WebPushSubscriber } from "@/components/altiora/WebPushSubscriber";
import { pageTransition, useSafeMotion } from "@/components/altiora/motion";

export default function AppShell() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const transition = useSafeMotion(pageTransition);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F7F3] text-[#5B5B62] font-mono text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (user.must_change_password && location.pathname !== "/app/account") {
    return <Navigate to="/app/account?force=1" replace />;
  }

  return (
    <div className="min-h-screen bg-[#F8F7F3] text-[#1F2937] flex flex-col">
      <ActiveRoleBanner />
      <AppTopBar />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 min-w-0 flex flex-col">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={location.pathname}
              {...transition}
              className="flex-1 min-h-0 flex flex-col"
              data-testid="app-page-container">
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
      <CommandPalette />
      <FeedbackAutoPrompt />
      <WebPushSubscriber />
    </div>
  );
}
